// import Toasted from 'vue-toasted'

export default defineNuxtPlugin(({ vueApp }) => {
  // vueApp.use(Toasted);
});
